import { Clock } from "lucide-react";

const DocumentCard = ({ doc, styles, theme, isSelected, getFileIcon, formatDate, handleDocumentClick }) => {
  const FileIcon = getFileIcon(doc.format);

  return (
    <div
      key={doc.id}
      style={styles.documentCard(isSelected)}
      onClick={() => handleDocumentClick(doc)}
      // onMouseEnter={(e) => {
      //   e.currentTarget.style.transform = "translateY(-6px)";
      //   e.currentTarget.style.boxShadow = isSelected
      //     ? "0 20px 55px rgba(59, 130, 246, 0.5), 0 10px 28px rgba(59, 130, 246, 0.4)"
      //     : theme === "dark"
      //       ? "0 15px 45px rgba(0, 0, 0, 0.5), 0 8px 22px rgba(0, 0, 0, 0.4)"
      //       : "0 15px 45px rgba(0, 0, 0, 0.15), 0 8px 22px rgba(0, 0, 0, 0.1)";
      // }}
      // onMouseLeave={(e) => {
      //   e.currentTarget.style.transform = "translateY(0)";
      //   e.currentTarget.style.boxShadow = isSelected
      //     ? "0 15px 45px rgba(59, 130, 246, 0.4), 0 8px 22px rgba(59, 130, 246, 0.3)"
      //     : theme === "dark"
      //       ? "0 10px 30px rgba(0, 0, 0, 0.4), 0 5px 15px rgba(0, 0, 0, 0.3)"
      //       : "0 10px 30px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.06)";
      // }}
    >
      <div style={styles.fileIconContainer(doc.color)}>
        <FileIcon size={44} color={doc.color} />
      </div>

      <h4 style={styles.documentName}>{doc.name}</h4>

      <div style={styles.documentMeta}>
        <span>{doc.format}</span>
        <span>•</span>
        <span>{doc.size}</span>
      </div>

      <div style={{ textAlign: "center", marginBottom: "12px" }}>
        <span style={styles.statusBadge(doc.status)}>{doc.status}</span>
      </div>

      <div style={styles.documentDate}>
        <Clock size={16} />
        {formatDate(doc.uploadDate)}
      </div>
    </div>
  );
};

export default DocumentCard;